import type { FC, PropsWithChildren } from 'react';

import { styled } from 'styled-components';

import { media } from '~/components/shared/core/styles';

const CSSLargeScreenOnlyWrapper = styled.div`
  display: none;

  @media ${({ theme }) => media(theme).greaterThan('lg')} {
    display: contents;
  }
`;

export const CSSLargeScreenOnly: FC<PropsWithChildren> = ({ children }) => (
  <CSSLargeScreenOnlyWrapper>{children}</CSSLargeScreenOnlyWrapper>
);
